import { ApproveSquirrel } from 'Icons'

const NoPostToApprove: React.FC = () => {
  return (
    <div className="relative flex h-[45px] items-center justify-center overflow-hidden whitespace-nowrap rounded-[5px] border border-solid border-green-500 bg-[#f0f8e7] text-center font-bold text-green-500">
      <div className="grid grid-cols-[50px_auto_50px] items-center gap-2">
        <span aria-hidden="true" />
        <span className="text-sm">No posts awaiting approval.</span>
        <ApproveSquirrel
          aria-hidden="true"
          className="relative top-[10px] w-[50px]"
        />
      </div>
    </div>
  )
}

export default NoPostToApprove
